import { Injectable } from '@angular/core';
import { RestService } from '../../shared/service/rest.service';
import { Observable } from 'rxjs';
import { VehicleGroup } from '../model/vehicle-group';

@Injectable()
export class VehicleGroupService extends RestService {

  fetchAllVehicleGroups(): Observable<VehicleGroup[]> {
    return this.getAndExtract<VehicleGroup>(VehicleGroup, 'api/vehicle/groups');
  }

  deleteVehicleGroup(groupId: number): Observable<VehicleGroup> {
    return this.deleteAndExtractSingle<VehicleGroup>(VehicleGroup, `api/vehicle/groups/${groupId}`);
  }

  saveVehicleGroup(vehicleGroup: VehicleGroup): Observable<VehicleGroup> {
    return this.postAndExtractSingle(VehicleGroup, 'api/vehicle/groups', vehicleGroup);
  }
}
